(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('Search', Search);

    Search.$inject = ['$resource'];

    function Search($resource) {
        var resourceUrl =  'public/api/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'POST', isArray: true},
            'aggs': {
              url: 'public/api/aggs',
              method: 'POST',
              isArray: false
            }
        });
    }
})();
